import { faEdit } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Accordion, Button, Col, Row, Table } from '@themesberg/react-bootstrap'
import React from 'react'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import Preloader from '../../../components/Preloader'
import EditUploadBanner from './EditUploadBanner'
import Trigger from '../../../components/OverlayTrigger'
import { bannerType } from './constants'
import { motion } from 'framer-motion/dist/framer-motion'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import ActionMenu from './ActionMenu'
import DeblurIcon from '@mui/icons-material/Deblur'
import PaginationComponent from '../../../components/Pagination'
import useAffiliateManagement from './useAffiliateManagement'
import AffiliateApprovalRejectionForm from './AffiliateApprovalRejectionForm'

export default () => {
  const {
    page,
    limit,
    setPage,
    setLimit,
    loading,
    handleDelete,
    handleCreateEdit,
    type,
    data,
    setShow,
    show,
    createUpdate,
    clientsFilterData,
    portalsFilterData,
    dispatch,
    affiliateRequests,
    isHidden,
    validation,
    setValidation,
    totalPages,
    setShowAffiliateModal,
    showAffiliateModal,
    selectedUser,
    setSelectedUser,
    navigate
  } = useAffiliateManagement()

  return (
    <>
      <div className='section-header-wrap mt-n3 mx-n3'>
        <Row>
          <Col lg={8} xs={7}>
            <h2 className='title-text'>Affiliate Requests</h2>
          </Col>
        </Row>
      </div>
      {loading
        ? <Preloader />
        :
        <div className='TableBg mt-4'>
          <Table striped responsive hover size='sm' className='text-center'>
            <thead className='thead-light'>
              <tr>
                {['id', 'Username', 'Email', 'Document Label', 'Document', 'Status', 'Action'].map((h) => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {affiliateRequests?.rows?.map(
                ({ userId, affiliateId, username, email, status, image, trackingToken }, index) => {
                  return (
                    <tr key={affiliateId}>
                      <td>{affiliateId}</td>
                      <td>
                        <span
                          style={{
                            width: '100px',
                            cursor: 'pointer'
                          }}
                          className='text-link d-inline-block text-truncate'
                          onClick={() =>
                            navigate(`/admin/users/details/${userId}`)}
                        >
                          {username}
                        </span>
                      </td>                      <td>{email}</td>
                      <td>{trackingToken}</td>
                      <td>
                        <span
                          onClick={() => window.open(`${process.env.REACT_APP_S3_URL}/${image}`)}
                          className='text-link'
                          style={{ cursor: 'pointer' }}
                        >
                          View Here
                        </span>
                      </td>
                      <td>{status.toUpperCase()}</td>


                      <td>
                        <ActionMenu
                          handleEditAffiliate={() => {
                            setSelectedUser({ username: username, trackingToken: trackingToken, affiliateId: affiliateId, userId: userId })
                            setShowAffiliateModal(true)
                          }}
                          handleDelete={handleDelete}
                          name={email}
                          thumbnail={''}
                          bannerType={''}
                        />
                      </td>
                    </tr>
                  )
                }
              )}

              {(!affiliateRequests || affiliateRequests?.length === 0) && (
                <tr>
                  <td colSpan={4} className='text-danger text-center'>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>}

      <AffiliateApprovalRejectionForm
        selectedUser={selectedUser}
        show={showAffiliateModal}
        dispatch={dispatch}
        handleClose={() => setShowAffiliateModal(false)}
        page={page}
        limit={limit}
      />

      {affiliateRequests?.count !== 0 && !loading && (
        <PaginationComponent
          page={affiliateRequests?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
        />
      )}


    </>
  )
}
